;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('InputDropdownMultipleController', InputDropdownMultipleController)

  /* @ngInject */
  function InputDropdownMultipleController ($scope, $attrs, $timeout) {
    const api = {
      _emitChanges,
      _onAdd,
      _onRemove
    }
    this.getApi = () => api

    activate()

    function activate () {
      $timeout(() => {
        $attrs.$$element.find('.input-dropdown-multiple').dropdown({
          onAdd: api._onAdd,
          onRemove: api._onRemove
        })
      }, 100, false)
    }

    $scope.onLastRepeatDropdownOption = function () {
      if ($scope.value) {
        $timeout(() => {
          $attrs.$$element.find('.input-dropdown-multiple').dropdown('set selected', $scope.value)
        }, 100, false)
      }
    }

    function _onAdd (value) {
      if (!$scope.model) {
        $scope.model = []
      }

      if ($scope.model.includes(value)) {
        return
      }

      $scope.model.push(value)
      api._emitChanges($scope.model)
    }

    function _onRemove (value) {
      if (!$scope.model) {
        return
      }
      const index = $scope.model.indexOf(value)
      if (index > -1) {
        $scope.model.splice(index, 1)
        api._emitChanges($scope.model)
      }
    }

    function _emitChanges (value) {
      if ($scope.change) {
        $scope.change({
          modelPropertyName: $scope.modelPropertyName,
          modelNewValue: value
        })
      }
      if (!$scope.$$phase) $scope.$apply()
    }
  }
})()
